export default __webpack_public_path__ + "static/media/img2.07de590d.PNG";